import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx'
import { ModalController, NavController } from '@ionic/angular'
import { TranslateService } from '@ngx-translate/core'

import { SharedAnalyticsService } from '../../../../shared/analytics/shared-analytics/shared-analytics.service'
import { EAnalyticsPageViews } from '../../../../shared/enums/analytics.enum'
import { EventInteraction, GTMInteractions, SECTIONS } from '../../../../shared/models/Constants'
import { AnalyticsService } from '../../../../shared/services/analytics.service'
import { YoutubeService } from '../../../../shared/services/youtube/youtube.service'
import { Noticias } from '../../models/Noticias'
import { ZoomImagePage } from '../zoom-image/zoom-image.page'

@Component({
  selector: 'app-modal-detail',
  templateUrl: './modal-detail.component.html',
  styleUrls: ['./modal-detail.component.scss'],
})
export class ModalDetailComponent implements OnInit, OnDestroy {

  @Input() noticia: Noticias = null

  public fontSize = 16
  public openModal: HTMLIonModalElement = null
  public imgHasError = false
  public isIos = false
  public logoPepsi: string = ''
  public imgPlaceholderYt: string = ''

  constructor(
    private modalController: ModalController,
    private inAppBrowser: InAppBrowser,
    private analyticsService: AnalyticsService,
    private nav: NavController,
    private youtubeService: YoutubeService,
    private translate: TranslateService,
    private sharedAnalyticsS: SharedAnalyticsService
  ) { }

  ngOnInit(): void {
    this.isIos = this.youtubeService.isIOS()
    this.logoPepsi = this.translate.instant('Icons.logo-pepsi')
    this.imgPlaceholderYt = this.translate.instant('Icons.img-placeholder-youtube')
    this.sendAnalyticScreen()
  }

  ngOnDestroy(): void {
    if (this.openModal !== null) {
      this.openModal.dismiss()
    }
  }

  public get videoId(): string {
    return this.youtubeService.extractVideoId(this.noticia?.Recurso || '')
  }

  public get thumbnailUrl(): string {
    return this.youtubeService.getThumbnailUrl(this.videoId)
  }

  public async openYouTubeApp(): Promise<void> {
    await this.youtubeService.openVideo(this.videoId)
  }

  public decreaseFont = (): void => {
    this.fontSize = this.fontSize > 16 ? this.fontSize - 1 : this.fontSize
  }

  public increaseFont = (): void => {
    this.fontSize = this.fontSize < 24 ? this.fontSize + 1 : this.fontSize
  }

  public closeModal = (): void => {
    this.modalController.dismiss(true)
    this.analyticsService.sendEventAnalytics(GTMInteractions.closeNewsDetailEvent, EventInteraction)
  }

  public openModalZoom = async (image: string): Promise<void> => {
    if (!this.imgHasError) {
      this.openModal = await this.modalController.create({
        component: ZoomImagePage,
        mode: 'md',
        backdropDismiss: true,
        cssClass: 'ion-modal-zoom',
        componentProps: { Imagen: this.noticia.Recurso }
      })

      await this.openModal.present()
      await this.openModal.onDidDismiss()
    }
  }

  public urlRedirect = (description: string): void => {
    if (description.includes('external-link')) {
      const urlRedirect = description.split('[')[1].split(']')[0]
      this.inAppBrowser.create(urlRedirect, '_system')
    } else if (description.includes('internal-link')) {
      const pathRedirect = description.split('[')[1].split(']')[0]
      this.nav.navigateForward([`/${pathRedirect}`], { animated: true, animationDirection: 'forward' })
    }
  }

  public errorEvent = (): void => {
    this.imgHasError = true
  }

  public onImageError = (event: Event): void => {
    const img = event.target as HTMLImageElement
    img.src = this.logoPepsi
    img.className = 'error-image'
    this.imgHasError = true
  }

  private sendAnalyticScreen = (): void => {
    const event = {
      ...EAnalyticsPageViews.newsDetailView,
      additionalPropertys: [
        { key: 'nombre_detalle', value: `${this.noticia.Titulo} ${this.noticia.ID_Noticia}` },
        { key: 'fecha_vigencia_inicial', value: this.noticia.FechaVigenciaInicial },
        { key: 'fecha_vigencia_final', value: this.noticia.FechaVigenciaFinal },
        { key: 'fecha_alta', value: this.noticia.FechaAlta }
      ]
    }

    this.sharedAnalyticsS.trackPageView(event, SECTIONS.PARA_TI)
  }
}
